<div class="address-form-container" [formGroup]="addressForm">
  <div fxLayout="row" fxLayoutGap="15px">
    <div fxFlex="100" fxFlex.lt-md="100%" *ngIf="!foreignActivitiesType">
      <mat-card class="address-form-card">
        <div fxLayout="row">
          <h3>{{title}}</h3>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
<!--            <mat-form-field class="address-input" >-->
<!--              <mat-label>Ulica</mat-label>-->
<!--              <input appCapitalizeFirst matInput placeholder="Jana Pawła II" formControlName="street" [required]="required">-->
<!--              <mat-error *ngIf="addressForm.get('street').hasError('required')">To pole jest wymagane</mat-error>-->
<!--            </mat-form-field>-->
            <app-dict-address
              fxFlex="100" label="Ulica"
              [control]="streetControl" [required]="required"
              [dictType]="[ADDRESS_IMPORT_TYPE_STREET, ADDRESS_IMPORT_TYPE_COMMUNE]"
            ></app-dict-address>
          </div>

          <div fxFlex="50">
            <mat-form-field class="address-input address-input-inline-left">
              <mat-label>Nr budynku</mat-label>
              <input appCapitalizeFirst matInput placeholder="15G" formControlName="houseNumber" [required]="required">
              <mat-error *ngIf="addressForm.get('houseNumber').hasError('required')">To pole jest wymagane</mat-error>
            </mat-form-field>
            <mat-form-field class="address-input address-input-inline">
              <mat-label>Nr mieszkania</mat-label>
              <input appCapitalizeFirst matInput placeholder="12" formControlName="apartmentNumber">
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50" *ngIf="!simple">
<!--            <mat-form-field class="address-input">-->
<!--              <mat-label>Poczta</mat-label>-->
<!--              <input appCapitalizeFirst matInput placeholder="Warszawa" formControlName="postCity" [required]="required">-->
<!--              <mat-error *ngIf="addressForm.get('postCity').hasError('required')">To pole jest wymagane</mat-error>-->
<!--            </mat-form-field>-->
            <app-dict-address
              fxFlex="100" label="Poczta"
              [control]="postCityControl" [required]="required"
              [dictType]="[ADDRESS_IMPORT_TYPE_COMMUNE]"
            ></app-dict-address>
          </div>

          <div fxFlex="50" *ngIf="simple">
<!--            <mat-form-field class="address-input">-->
<!--              <mat-label>Miejscowość</mat-label>-->
<!--              <input appCapitalizeFirst matInput placeholder="Warszawa" formControlName="city" [required]="required">-->
<!--              <mat-error *ngIf="addressForm.get('city').hasError('required')">To pole jest wymagane</mat-error>-->
<!--            </mat-form-field>-->
            <app-dict-address
              fxFlex="100" label="Miejscowość"
              [control]="cityControl" [required]="required"
              [dictType]="[ADDRESS_IMPORT_TYPE_COMMUNE]"
            ></app-dict-address>
          </div>

          <div fxFlex="50">
            <mat-form-field class="address-input">
              <mat-label>Kod pocztowy</mat-label>
              <input matInput placeholder="10-200" formControlName="zipCode" [required]="required" mask="99-999" [showMaskTyped]="true" [dropSpecialCharacters]="false">
              <mat-error *ngIf="addressForm.get('zipCode').hasError('required')">To pole jest wymagane</mat-error>
              <mat-error *ngIf="addressForm.get('zipCode').hasError('invalidZipCode')">Podaj prawidłowy kod pocztowy</mat-error>
              <mat-error *ngIf="addressForm.get('zipCode').hasError('pattern')">Podaj prawidłowy kod pocztowy</mat-error>
              <mat-error *ngIf="addressForm.get('zipCode').hasError('minLength')">Podaj prawidłowy kod pocztowy</mat-error>

            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px" *ngIf="requirePzuData">
          <div fxFlex="50">
            <!--            <mat-form-field class="address-input">-->
            <!--              <mat-label>Powiat</mat-label>-->
            <!--              <input matInput placeholder="starogardzki" formControlName="district" [required]="required">-->
            <!--              <mat-error *ngIf="addressForm.get('district').hasError('required')">To pole jest wymagane</mat-error>-->
            <!--            </mat-form-field>-->
            <app-dict-address
              fxFlex="100" label="Powiat"
              [control]="districtControl" [required]="required"
              [dictType]="[ADDRESS_IMPORT_TYPE_DISTRICT]"
            ></app-dict-address>
          </div>

          <div fxFlex="50">
            <!--            <mat-form-field class="address-input">-->
            <!--              <mat-label>Gmina</mat-label>-->
            <!--              <input appCapitalizeFirst matInput placeholder="Starogard Gdański" formControlName="commune" [required]="required">-->
            <!--              <mat-error *ngIf="addressForm.get('commune').hasError('required')">To pole jest wymagane</mat-error>-->
            <!--            </mat-form-field>-->
            <app-dict-address
              fxFlex="100" label="Gmina"
              [control]="communeControl" [required]="required"
              [dictType]="[ADDRESS_IMPORT_TYPE_COMMUNE]"
            ></app-dict-address>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100" *ngIf="requirePzuData">
            <!--            <mat-form-field class="address-input">-->
            <!--              <mat-label>Poczta</mat-label>-->
            <!--              <input appCapitalizeFirst matInput placeholder="Warszawa" formControlName="postCity" [required]="required">-->
            <!--              <mat-error *ngIf="addressForm.get('postCity').hasError('required')">To pole jest wymagane</mat-error>-->
            <!--            </mat-form-field>-->
            <app-dict-address
              fxFlex="100" label="Poczta"
              [control]="postCityControl" [required]="required"
              [dictType]="[ADDRESS_IMPORT_TYPE_COMMUNE]"
            ></app-dict-address>
          </div>
        </div>


        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50" *ngIf="!simple">
<!--            <mat-form-field class="address-input">-->
<!--              <mat-label>Miejscowość</mat-label>-->
<!--              <input appCapitalizeFirst matInput placeholder="Warszawa" formControlName="city" [required]="required">-->
<!--              <mat-error *ngIf="addressForm.get('city').hasError('required')">To pole jest wymagane</mat-error>-->
<!--            </mat-form-field>-->

            <app-dict-address
              fxFlex="100" label="Miejscowość"
              [control]="cityControl" [required]="true"
              [dictType]="[ADDRESS_IMPORT_TYPE_COMMUNE]"
            ></app-dict-address>
          </div>

          <div [fxFlex]="simple ? '100' : '50'">
            <app-dict class="address-input" [label]="'Województwo'" [dictType]="'address_state'" [control]="stateControl"
                      [required]="required"></app-dict>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px" *ngIf="!simple">
          <div fxFlex="50">
<!--            <mat-form-field class="address-input">-->
<!--              <mat-label>Powiat</mat-label>-->
<!--              <input matInput placeholder="starogardzki" formControlName="district" [required]="required">-->
<!--              <mat-error *ngIf="addressForm.get('district').hasError('required')">To pole jest wymagane</mat-error>-->
<!--            </mat-form-field>-->
            <app-dict-address
              fxFlex="100" label="Powiat"
              [control]="districtControl" [required]="true"
              [dictType]="[ADDRESS_IMPORT_TYPE_DISTRICT]"
            ></app-dict-address>
          </div>

          <div fxFlex="50">
<!--            <mat-form-field class="address-input">-->
<!--              <mat-label>Gmina</mat-label>-->
<!--              <input appCapitalizeFirst matInput placeholder="Starogard Gdański" formControlName="commune" [required]="required">-->
<!--              <mat-error *ngIf="addressForm.get('commune').hasError('required')">To pole jest wymagane</mat-error>-->
<!--            </mat-form-field>-->
            <app-dict-address
              fxFlex="100" label="Gmina"
              [control]="communeControl" [required]="true"
              [dictType]="[ADDRESS_IMPORT_TYPE_COMMUNE]"
            ></app-dict-address>
          </div>
        </div>

      </mat-card>
    </div>

    <div fxFlex="100" fxFlex.lt-md="100%" *ngIf="foreignActivitiesType">
      <mat-card class="address-form-card">
        <div fxLayout="row">
          <h3>{{title}}</h3>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
<!--            <mat-form-field class="address-input" >-->
<!--              <mat-label>Ulica</mat-label>-->
<!--              <input appCapitalizeFirst matInput placeholder="Jana Pawła II" formControlName="street" [required]="required">-->
<!--              <mat-error *ngIf="addressForm.get('street').hasError('required')">To pole jest wymagane</mat-error>-->
<!--            </mat-form-field>-->
            <app-dict-address
              fxFlex="100" label="Ulica"
              [control]="streetControl" [required]="true"
              [dictType]="[ADDRESS_IMPORT_TYPE_STREET, ADDRESS_IMPORT_TYPE_COMMUNE]"
            ></app-dict-address>
          </div>

          <div fxFlex="50">
            <mat-form-field class="address-input address-input-inline-left">
              <mat-label>Nr budynku</mat-label>
              <input appCapitalizeFirst matInput placeholder="15G" formControlName="houseNumber" [required]="required">
              <mat-error *ngIf="addressForm.get('houseNumber').hasError('required')">To pole jest wymagane</mat-error>
            </mat-form-field>
            <mat-form-field class="address-input address-input-inline">
              <mat-label>Nr mieszkania</mat-label>
              <input appCapitalizeFirst matInput placeholder="12" formControlName="apartmentNumber">
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">

          <div fxFlex="50" >
<!--            <mat-form-field class="address-input">-->
<!--              <mat-label>Miejscowość</mat-label>-->
<!--              <input appCapitalizeFirst matInput placeholder="Warszawa" formControlName="city" [required]="required">-->
<!--              <mat-error *ngIf="addressForm.get('city').hasError('required')">To pole jest wymagane</mat-error>-->
<!--            </mat-form-field>-->
            <app-dict-address
              fxFlex="100" label="Miejscowość"
              [control]="cityControl" [required]="true"
              [dictType]="[ADDRESS_IMPORT_TYPE_COMMUNE]"
            ></app-dict-address>
          </div>

          <div fxFlex="50">
            <mat-form-field class="address-input">
              <mat-label>Kod pocztowy</mat-label>
              <input matInput placeholder="10-200" formControlName="zipCode" [required]="required" mask="99-999" [showMaskTyped]="true" [dropSpecialCharacters]="false">
              <mat-error *ngIf="addressForm.get('zipCode').hasError('required')">To pole jest wymagane</mat-error>
              <mat-error *ngIf="addressForm.get('zipCode').hasError('invalidZipCode')">Podaj prawidłowy kod pocztowy</mat-error>
            </mat-form-field>
          </div>
        </div>



      </mat-card>
    </div>

  </div>
</div>
